import { Tab, TabProps } from "@mui/material";
import { forwardRef } from "react";

interface IBybTab {
  label: string;
  index: number;
  size?: "small" | "medium" | "large";
}

const BybTab = forwardRef<HTMLDivElement, TabProps & IBybTab>((props, ref) => {
  const { index, size = "small", ...rest } = props;

  const typographyMap = {
    small: "textS500",
    medium: "textBase500",
    large: "text1xl500",
  } as const;

  return (
    <Tab
      ref={ref}
      id={`simple-tab-${index}`}
      aria-controls={`simple-tabpanel-${index}`}
      {...rest}
      sx={(theme) => ({
        zIndex: 1,
        textTransform: "capitalize",
        padding: theme.spacing(0.75, 1.5),
        color: "dsNeutral.v300",
        minHeight: 0,
        "&.Mui-selected": {
          color: "dsBase.v200",
        },
        ...theme.typography[typographyMap[size]],
      })}
      disableRipple
    />
  );
});

BybTab.displayName = "BybTab";

export default BybTab;
